$('.tooltipster').tooltipster({
  theme: 'tooltipster-light',
  maxWidth: 320,
});
